import {
    GLOBAL_DATA_CONFIGURATOR_RECEIVE,
} from '../constants';

const DEFAULT_STATE = {
    mainHeaderData: {},
    mainFooterData: {},
    globalModalHeaderDataContainer: {},
    globalHeaderDataContainer: {},
    globalInfoDataContainer: {},
};

export const genericGlobalData = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
      case GLOBAL_DATA_CONFIGURATOR_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
